export default {
  name: 'ResetPasswordForm',
  props: ['errors'],
  data() {
    return {
      form: {
        password1: null,
        password2: null
      }
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.form);
    },
    reset() {
      this.form = {
        password1: null,
        password2: null
      };
    }
  }
};